

































































import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/@types';
import ChartPie from '@/components/ChartPie.vue';
import ChartBar from '@/components/ChartBar.vue';
import ChartArea from '@/components/ChartArea.vue';
import ChartLine from '@/components/ChartLine.vue';

@Component({
  components: {
    ChartPie,
    ChartBar,
    ChartArea,
    ChartLine
  }
})
export default class HomePage extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  isRegister: boolean = false;
  validLogin: boolean = true;
  showLoginPassword: boolean = false;
  validRegister: boolean = true;
  showRegisterPassword: boolean = false;
  // Login data
  loginUsername: string = '';
  loginPassword: string = '';
  // Register data
  registerUsername: string = '';
  registerPassword: string = '';
  confirmPassword: string = '';

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get isLoading(): boolean {
    return this.$store.state.user.isLoading;
  }

  get userList(): User[] {
    return this.$store.state.user.userList;
  }
}
